module.exports = __webpack_public_path__ + "img/icon-customer-service.7859a614.svg";